import React from 'react';

import PricingPage from './PricingPage';

/**
 * InteriorPricingPage
 * @returns {{}}
 */
export default function InteriorPricingPage() {
  return (
    <PricingPage showMediaPlayerPricing />
  );
}
